

/// <reference path="StockNote.ts" />

// Generated class ProductionNote_ManagedObject

class ProductionNote_ManagedObject extends StockNote
{
}
